export default {
  path: '/wkzfsq',
  name: 'NoCardAuth',
  meta: { title: '无卡支付授权' },
  component: () => import('@/views/NoCardAuth'),
  children: [
    {
      path: '',
      name: 'defaultCard',
      meta: { title: '无卡支付授权' },
      component: () => import('@/views/NoCardAuth/DefaultCard')
    },
    {
      path: 'bindlist',
      name: 'BindList',
      meta: { title: '无卡支付授权' },
      component: () => import('@/views/NoCardAuth/bindList')
    },
    {
      path: 'bindSearch',
      name: 'bindSearch',
      meta: { title: '电子卡绑卡一览表', noCard: true },
      component: () => import('@/views/NoCardAuth/filterBind')
    },
    {
      path: 'bindDetail',
      name: 'bindDetail',
      meta: { title: '电子卡绑卡一览表', noCard: true },
      component: () => import('@/views/NoCardAuth/bindDetail')
    },
    {
      path: 'historySearch',
      name: 'historySearch',
      meta: { title: '电子卡绑卡解绑轨迹查询', noCard: true },
      component: () => import('@/views/NoCardAuth/filterHistory')
    },
    {
      path: 'bindHistory',
      name: 'bindHistory',
      meta: { title: '电子卡绑卡解绑轨迹查询', noCard: true },
      component: () => import('@/views/NoCardAuth/bindHistory')
    }
  ]
}
